import { render, staticRenderFns } from "./contactStaffDetail.vue?vue&type=template&id=2c550e84&scoped=true"
import script from "./contactStaffDetail.vue?vue&type=script&lang=js"
export * from "./contactStaffDetail.vue?vue&type=script&lang=js"
import style0 from "./contactStaffDetail.vue?vue&type=style&index=0&id=2c550e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c550e84",
  null
  
)

export default component.exports